<template>
  <div class="body_area after_bg sm">

    <div class="block-header">
      <div class="container">
        <div class="row clearfix">
          <div class="col-lg-6 col-md-12">
            <h1 class="mb-1 mt-1">{{title}}</h1>
          </div>
        </div>
        <div class="bh_divider"></div>
        <div class="row clearfix">
          <div class="col-lg-12 col-md-12">
            <nav class="navbar navbar-expand-lg page_menu">
              <div class="collapse navbar-collapse" id="Blog_app" style="display: block;">
                <ul class="navbar-nav mr-auto">
                  <li class="nav-item "><a href="javascript:void(0);" class="nav-link"  @click="toLeadPage">리드</a></li>
                  <li class="nav-item active"><a href="javascript:void(0);" class="nav-link"  @click="toListPage">리스트</a></li>
                </ul>
                <div>
                  &nbsp;
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>

  <div class="container">
  <div class="row clearfix row-deck">
    <div class="col-lg-7 col-md-12">
      <div class="card visitors-map">
        <div class="header">
          <h2>리드</h2>
        </div>
        <div class="table-responsive" style="min-height: 500px;">
          <table class="table table-hover mb-0" style="text-align: center;">
            <thead>
            <tr>
              <th>#</th>
              <th>이메일</th>
              <th>생성일</th>
              <th>설정</th>
            </tr>
            </thead>
            <tbody v-if="list != null && list.length != 0">
            <tr v-for="(lead, index) of list" v-bind:key="index">
              <td>{{countingIndex(index)}}</td>
              <td @click="detailLead(index)">{{lead.email}}</td>
              <td>{{lead.insertDt}}</td>
              <td><button type="button" class="btn btn-success" @click="editLead(lead.leadCode)" style="color: white"> <font-awesome-icon :icon="faPen" /></button>
              <button type="button" class="btn btn-danger" @click="deleteLead(lead.leadCode)"><font-awesome-icon :icon="faTrash" /></button></td>
            </tr>


            </tbody>

            <tbody v-if="list == null || list.length == 0">
            <tr >
              <td colspan="4"> 리드가 없습니다. </td>
            </tr>



            </tbody>

          </table>
        </div>

        <div>
          <div class="justify-content-center">
            <ul class="pagination pagination-primary" style="justify-content: center;">
              <li class="page-item arrow-margin-left" v-if="pageNum > 1" @click="changePage(1)">
                <a class="page-link" href="javascript:void(0);" aria-label="Previous" >
                  <span aria-hidden="true"><i class="zmdi zmdi-chevron-left" aria-hidden="true"></i></span>
                </a>
              </li>

              <li class="page-item" :class="{'active' : pageNum == num}" v-for="num in Math.ceil(totalCount/20)" :key="num" @click="changePage(num)" ><a class="page-link" href="javascript:void(0);">{{num}}</a></li>

              <li class="page-item arrow-margin-right" v-if="Math.ceil(totalCount/20) > 1">
                <a class="page-link" href="javascript:void(0);" aria-label="Next" @click="changePage(pageNum + 1)">
                  <span aria-hidden="true"><i class="zmdi zmdi-chevron-right" aria-hidden="true"></i></span>
                </a>
              </li>
            </ul>
          </div>
        </div>



      </div>
    </div>
    <div class="col-lg-5 col-md-12">
      <div class="card">
        <div class="header">
          <h2>상세 조회</h2>

        </div>
        <div class="container" v-if="!clickedLead" style="min-height: 400px;">
          리드를 클릭
        </div>
        <div class="container" v-if="clickedLead">
          <!-- Example Tab -->
          <div class="row clearfix">
            <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="body">
                  <!-- Nav tabs -->
                  <ul class="nav nav-tabs">
                    <li class="nav-item"><a class="nav-link" data-toggle="tab" href="javascript:void(0);" :class="{'active' : sideTab == 0}" @click="sideShowProfile(0)">활동정보</a></li>
                    <li class="nav-item"><a class="nav-link" data-toggle="tab" href="javascript:void(0);" :class="{'active' : sideTab == 1}" @click="sideShowProfile(1)">프로필</a></li>
                    <li class="nav-item"><a class="nav-link" data-toggle="tab" href="javascript:void(0);" :class="{'active' : sideTab == 2}" @click="sideShowProfile(2)">리스트</a></li>
                  </ul>
                  <!-- Tab panes -->
                  <div class="tab-content mt-3" style="min-height: 500px;">
                    <div role="tabpanel" class="tab-pane in" id="home" :class="{'active' : sideTab == 0}">

                      <div class="body">
                        <div class="panel-group" id="accordion_1" role="tablist" aria-multiselectable="true">
                          <div class="panel" v-for="(track, index) in tracking" :key="index">
                            <div class="panel-heading" role="tab" id="headingOne_1" @click="collapsedBox(index)" >
                              <h4 class="panel-title">
                                <a role="button" data-toggle="collapse" data-parent="#accordion_1" href="#collapseOne_1" aria-expanded="true" aria-controls="collapseOne_1">방문한 페이지 : {{track.pageName}}</a>
                              </h4>
                            </div>
                            <div class="panel-collapse collapse in show trackingCollapse" role="tabpanel" aria-labelledby="headingOne_1" style="display: none;">
                              <div class="panel-body">

                                <ul>
                                  <li>url :
                                    <br>{{track.url}}
                                  </li>
                                  <li>페이지 제목 : <br>{{track.title}}</li>
                                  <li>접속 IP : <br>{{track.remoteAddr}}</li>
                                  <li>OS : <br>{{track.os}}</li>
                                  <li>접속 브라우저 : {{track.browserName}} <br>({{track.browserVersion}})</li>
                                </ul>

                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                    <div role="tabpanel" class="tab-pane" id="profile" :class="{'active' : sideTab == 1}">
                      <p>이메일 : {{email}}</p>
                      <p>이름 : {{name}}</p>
                      <p>나이 : {{age}}</p>
                      <p>전화번호 : {{phone}}</p>
                      <p>회사 : {{company}}</p>
                      <p>생년월일 : {{birthday}}</p>
                      <p>성별 : {{gender}}</p>
                      <p>우편번호 : {{zipcode}}</p>
                      <p>주소 : {{address1}}</p>
                      <p>상세주소 : {{address2}}</p>
                      <p>리드점수 : {{leadScore}}</p>
                    </div>
                    <div role="tabpanel" class="tab-pane" id="messages" :class="{'active' : sideTab == 2}">
                      <div class="table-responsive">
                        <table class="table table-hover mb-0" >
                          <thead>
                          <tr>
                            <th>리스트명</th>
                          </tr>
                          </thead>
                          <tbody v-if="listGroup != null && listGroup.length != 0">
                            <tr v-for="(lead, index) of listGroup" v-bind:key="index">
                              <td>{{lead.leadGroupTitle}}</td>
                            </tr>
                          </tbody>
                          <tbody v-if="listGroup == null || listGroup.length == 0">
                          <tr >
                            <td colspan="4"> 등록된 리스트가 없습니다. </td>
                          </tr>


                          </tbody>

                        </table>
                      </div>


                    </div>
                  </div>
              </div>
            </div>
          </div>
          <!-- #END# Example Tab -->
      </div>
    </div>
  </div>
  </div>
    <footer-view />
  </div>
  </div>
</template>


<script>
import FooterView from "@/components/common/FooterView";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
// import { fa } from "@fortawesome/free-regular-svg-icons";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

export default {
  name: 'LeadInListPage',
  components: {
    FooterView,
    FontAwesomeIcon
  },
  data() {
    return {
      list : null,
      title : '제목',
      sideTab : 1,
      clickedLead : false,

      email : null,
      name : null,
      age : null,
      gender : null,
      birthday : null,
      company : null,
      phone : null,
      zipcode : null,
      address1 : null,
      address2 : null,
      leadScore : null,
      leadCode : null,

      tracking : null,
      listGroup : null,

      pageNum : 1,
      totalCount : 2,

      faPen,
      faTrash
    }
  },
  methods: {
    changePage(num){
      this.pageNum = num;

      this.getLeads();

    },
    countingIndex(index){

      return this.totalCount - (this.pageNum -1)*20 - index
    },
    editLead(code){
      console.log(code)

      this.$router.push({name:"LeadAddPage", params : {leadCode : code, status : '1'}})

    },
    deleteLead(code){
      console.log(code)

      if(confirm("삭제하시겠습니까?")){
        var param = {
          companyCode : this.$store.getters.getUserCode,
          leadGroupCode : this.$route.params.leadGroupCode,
          leadCode : code
        }

        this.api.removeLeadsFromLists(param)
          .then((res)=>{

            if(this.utils.preApiHandle(res)) {
              console.log("list list res : ", res)
            }

            if(res.code == 0){
              alert("삭제되었습니다.")
              this.getLeads();
            } else {
              alert("오류가 발생했습니다.")
            }
          })
      }

    },
    collapsedBox(index){

      if(document.getElementsByClassName("trackingCollapse")[index].style.display == "none"){
        document.getElementsByClassName("trackingCollapse")[index].style.display = "block";
      } else {
        document.getElementsByClassName("trackingCollapse")[index].style.display = "none";
      }
    },
    detailLead(index){

      console.log(index)

      var lead = this.list[index];

      this.leadCode = lead.leadCode
      this.email = lead.email
      this.name = lead.name
      this.age = lead.age
      this.gender = lead.gender
      this.birthday = lead.birthday
      this.company = lead.company
      this.phone = lead.phone
      this.zipcode = lead.zipcode
      this.address1 = lead.address1
      this.address2 = lead.address2
      this.leadScore = lead.leadScore



      this.clickedLead = !this.clickedLead;

      this.getLeadTrackGroups();

    },
    getLeadTrackGroups(){
      var param = {
        companyCode : this.$store.getters.getUserCode,
        leadCode : this.leadCode
      }

        console.log("get tracking")

        this.api.getLeadTracking(param)
          .then((res)=>{

            if(this.utils.preApiHandle(res)) {
              console.log("list list res : ", res)
            }
            console.log(res)

            if(res.code == 0){
              this.tracking = res.tracking;

            } else {
              alert("오류가 발생했습니다.")
            }

          })


        this.api.getLeadsList(param)
          .then((res)=>{

            if(this.utils.preApiHandle(res)) {
              console.log("list list res : ", res)
            }

            if(res.code == 0){
              console.log(res)
              this.listGroup = res.list;

            } else {
              alert("오류가 발생했습니다.")
            }


          })
    },

    sideShowProfile(num){

      this.sideTab = num;

    },
    toLeadPage(){
      this.$router.push({name:"LeadListPage"})
    },
    toListPage(){
      this.$router.push({name:"ListListPage"})
    },
    getLeads(){
      var param = {
        companyCode : this.$store.getters.getUserCode,
        leadGroupCode : this.$route.params.leadGroupCode,
        pageNum : 0,
        skipNum : this.pageNum-1
      }

      this.api.getListEachLeadList(param)
        .then((res)=>{

          if(this.utils.preApiHandle(res)) {
            console.log("list list res : ", res)
          }

          if(res.code == 0){
            console.log(res)
            this.list = res.leadList;
            this.totalCount = res.totalCount;

          } else {
            alert("오류가 발생했습니다.")
          }
        })

    }
  },
  created() {
    console.log('LeadInListPage created')

    console.log(this.$route.params.leadGroupCode)

    this.title = this.$route.params.title

    this.getLeads();


  },
  mounted() {
    console.log('LeadInListPage created')
  },
  beforeDestroy() {
    console.log('LeadInListPage beforeDestroy')
  }
}
</script>

